import React from 'react';
import { Dialog, IconButton, DialogContent, DialogActions, DialogTitle } from '@mui/material';
import ProjectsList from 'pages/ProjectsList';
import CloseIcon from '@mui/icons-material/Close';
import { GridRowId } from '@mui/x-data-grid';

interface PayapppProjectSelectionDialogProps {
  open: boolean;
  onClose: () => void;
  onSelect?: (selectedProjects: readonly GridRowId[]) => void;
  isFromReport?: boolean;
  disabledCompsIds?: string[];
  isAdding?: boolean;
  defaultOnDisplayFilters?: string[];
  prevAppliedFilters?: string;
  projectSearchQuery?: string;
  disableChecboxSelectionOnMaps?: boolean;
}

const PayapppProjectSelectionDialog: React.FC<PayapppProjectSelectionDialogProps> = ({
  open,
  onClose,
  onSelect,
  isFromReport,
  disabledCompsIds,
  isAdding,
  defaultOnDisplayFilters,
  prevAppliedFilters,
  projectSearchQuery,
  disableChecboxSelectionOnMaps,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDialog-paper': {
          maxWidth: '1500px',
          height: '900px',
        },
      }}
      fullWidth
      maxWidth='xl'
    >
      <DialogTitle sx={{ paddingBottom: 0 }}>{'Select Project for Payapp'}</DialogTitle>
      <IconButton onClick={onClose} style={{ position: 'absolute', right: 8, top: 8 }}>
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ paddingTop: 0 }}>
        <ProjectsList
          onProjectsSelect={(selected: readonly GridRowId[]) => {
            // Directly trigger onSelect and close dialog
            if (onSelect) {
              onSelect(selected);
            }
            onClose();
          }}
          isFromReport={isFromReport}
          disabledProjectsIds={disabledCompsIds}
          defaultOnDisplayFilters={defaultOnDisplayFilters}
          prevAppliedFilters={prevAppliedFilters}
          shouldRenderMinimalActions={true}
          projectSearchQuery={projectSearchQuery}
          disableChecboxSelectionOnMaps={disableChecboxSelectionOnMaps}
          enableSingleSelection={true}
        />
      </DialogContent>

      <DialogActions></DialogActions>
    </Dialog>
  );
};

export default React.memo(PayapppProjectSelectionDialog);
